import Backbone from 'backbone';
import _ from 'underscore';
import moment from 'moment';

import TravelModel from './travelmodel';
import AppointmentModel from './appointmentmodel';


var PageModel = Backbone.Model.extend({
  canFindAppointments: function() {
    if (this.travel.isValid()) {
      if (!this.travel.shouldCalculateJourney()) {
          if (this.get('eta')) return true;
      } else {
          if (this.get('journey')) return true;
      }
    }
    return false;
  },

  travelChanged: function(model, options) {
    if (this.travel.shouldCalculateJourney()) {
      this.unset('eta');
      this.unset('journey');
    }
    this.appointment.clear();
  },

  etaChanged: function(model, options) {
    this.appointment.clear();
  },

  arrivalDateTimeChanged: function(model, options) {
    var value = moment(
        [this.get('arrival_date'), this.get('arrival_time')].join('T')
    ).format('YYYY-MM-DDTHH:mm');
    this.set({'eta': value});
  },

  initialize: function() {
    this.travel = new TravelModel();
    this.appointment = new AppointmentModel();
    this.listenTo(this.travel, 'change', _.bind(this.travelChanged, this));
    this.listenTo(this, 'change:eta', _.bind(this.etaChanged, this));
    this.listenTo(this, 'change:arrival_time', _.bind(this.arrivalDateTimeChanged, this));
    this.listenTo(this, 'change:arrival_date', _.bind(this.arrivalDateTimeChanged, this));
  }
});

module.exports = PageModel;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/arrival/models/pagemodel.js
 **/